<template>
    <v-sheet
        rounded>
        <v-toolbar flat rounded>
            <v-toolbar-items class="me-2">
                <v-btn icon @click="$router.back()">
                    <v-icon>{{$vuetify.rtl ? "mdi-arrow-right" : "mdi-arrow-left"}}</v-icon>
                </v-btn>
            </v-toolbar-items>
            <v-toolbar-title>{{$t("REPORTS")}}</v-toolbar-title>
        </v-toolbar>
        <v-divider></v-divider>
        <router-view></router-view>
    </v-sheet>
</template>

<script>
export default {
    name: "ReportsView",
}
</script>

<style>

</style>